
export default function DifferentialsSection() {
  const differentials = [
    {
      icon: 'ri-brain-line',
      title: 'IA que gera valor real para o cliente',
      description: 'Algoritmos proprietários que maximizam o retorno sobre investimento'
    },
    {
      icon: 'ri-flashlight-line',
      title: 'Infraestrutura imediata',
      description: '45 telas instaladas, centenas de campanhas ativas e prontas para uso'
    },
    {
      icon: 'ri-user-heart-line',
      title: 'Conexão direta com o público certo',
      description: 'Segmentação inteligente baseada em dados comportamentais reais'
    },
    {
      icon: 'ri-rocket-line',
      title: 'Inovação contínua',
      description: 'Desenvolvimento constante em mídia indoor e outdoor inteligente'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Diferenciais da <span className="bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">See Media</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            O que nos torna únicos no mercado de mídia inteligente
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 max-w-6xl mx-auto">
          {differentials.map((item, index) => (
            <div 
              key={index}
              className="flex items-start space-x-6 p-8 bg-gray-50 rounded-2xl hover:bg-gray-100 transition-all duration-300"
            >
              <div className="flex-shrink-0">
                <div className="w-16 h-16 bg-gradient-to-r from-blue-600 to-purple-600 rounded-2xl flex items-center justify-center">
                  <i className={`${item.icon} text-white text-2xl`}></i>
                </div>
              </div>
              
              <div className="flex-1">
                <div className="flex items-center mb-3">
                  <i className="ri-check-line text-green-600 text-xl mr-2"></i>
                  <h3 className="text-xl font-bold text-gray-900">{item.title}</h3>
                </div>
                <p className="text-gray-600 leading-relaxed">{item.description}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <div className="bg-gradient-to-r from-gray-900 to-gray-800 rounded-2xl p-8 md:p-12 text-white relative overflow-hidden">
            <div className="absolute top-0 right-0 w-64 h-64 bg-gradient-to-br from-blue-600/20 to-purple-600/20 rounded-full filter blur-3xl"></div>
            <div className="relative z-10">
              <h3 className="text-3xl font-bold mb-4">Tecnologia Proprietária</h3>
              <p className="text-xl text-gray-300 mb-8 max-w-3xl mx-auto">
                Desenvolvemos nossa própria stack de IA, garantindo controle total sobre a qualidade, 
                precisão e evolução contínua de nossas soluções.
              </p>
              <div className="grid md:grid-cols-3 gap-8">
                <div className="text-center">
                  <div className="text-2xl font-bold text-blue-400">99.9%</div>
                  <div className="text-sm text-gray-400">Precisão na Detecção</div>
                </div>
                <div className="text-center">
                  <div className="text-2xl font-bold text-purple-400">&lt;100ms</div>
                  <div className="text-sm text-gray-400">Tempo de Resposta</div>
                </div>
                <div className="text-center">
                  <div className="text-2xl font-bold text-green-400">24/7</div>
                  <div className="text-sm text-gray-400">Monitoramento</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
